<nav class="fixed top-0 left-0 w-full z-50 transition-all duration-300" [ngClass]="{
    'bg-transparent shadow-none': isHome && !isScrolled && !isMenuOpen,
    'bg-primary shadow-sm': !isHome || isScrolled || isMenuOpen
  }">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="flex items-center justify-between h-16">

      <a routerLink="/" class="flex-shrink-0 flex items-center">
        <img src="logo.png" alt="V Congreso Argentino de Agroecología" class="h-10 w-auto" />
      </a>

      <div class="hidden md:flex items-center gap-5 lg:gap-7">
        <ng-container *ngFor="let link of navLinks">

          <div *ngIf="link.children && link.children.length > 0 && isLoggedIn()" class="relative group">
            <button [class.bg-primary-hover]="padreActivo(link)"
              class="px-3 py-2 rounded-md text-navbar-text hover:bg-primary-hover text-sm font-medium transition-colors flex items-center gap-1">
              {{ link.label }}
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            <div
              class="absolute left-0 mt-2 w-56 bg-primary rounded-lg shadow-xl ring-1 ring-white/10 overflow-hidden opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
              <a *ngFor="let child of link.children" [routerLink]="child.path"
                routerLinkActive="bg-primary-hover"
                class="block px-4 py-3 text-sm text-navbar-text hover:bg-primary-hover transition-colors">
                {{ child.label }}
              </a>
            </div>
          </div>

          <a *ngIf="!link.children || link.children.length === 0 || !isLoggedIn()" [routerLink]="link.path"
            routerLinkActive="bg-primary-hover" [routerLinkActiveOptions]="{ exact: !!link.exact }"
            class="px-3 py-2 rounded-md text-navbar-text hover:bg-primary-hover text-sm font-medium transition-colors duration-200">
            {{ link.label }}
          </a>
        </ng-container>

        <div class="pt-2">
          <a *ngIf="!isLoggedIn()" routerLink="/login" (click)="closeMenu()"
            class="flex items-center justify-center gap-2 w-full bg-navbar-text text-primary text-sm font-medium px-4 py-2.5 rounded-lg shadow-sm hover:bg-card hover:shadow-md transition-all duration-200">
            Iniciar sesión
          </a>

          <div *ngIf="isLoggedIn()" class="relative">
            <button (click)="toggleProfile($event)"
              class="flex items-center justify-center w-10 h-10 rounded-full bg-navbar-text text-primary shadow-sm hover:shadow-md hover:opacity-90 transition-all duration-200"
              [attr.aria-expanded]="profileOpen" aria-label="Perfil de usuario" title="{{ userName() }}">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
              </svg>
            </button>

            <div *ngIf="profileOpen"
              class="absolute right-0 mt-2 w-56 bg-primary rounded-lg shadow-xl ring-1 ring-white/10 overflow-hidden z-50">
              <div class="px-4 py-3 border-b border-white/10">
                <p class="text-sm font-semibold text-navbar-text truncate">{{ userName() }}</p>
              </div>
              <button (click)="logout()"
                class="w-full flex items-center gap-2 px-4 py-3 text-sm text-navbar-text hover:bg-primary-hover transition-colors text-left">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9" />
                </svg>
                Cerrar sesión
              </button>
            </div>
          </div>
        </div>
      </div>

      <button (click)="toggleMenu()"
        class="md:hidden inline-flex items-center justify-center p-2 rounded-md text-navbar-text hover:bg-primary-hover transition-colors duration-200 focus:outline-none"
        [attr.aria-expanded]="isMenuOpen" aria-label="Abrir menú de navegación">
        <svg *ngIf="!isMenuOpen" class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
        </svg>
        <svg *ngIf="isMenuOpen" class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  </div>

  <div *ngIf="isMenuOpen"
    class="md:hidden fixed inset-0 top-16 bg-primary z-40 overflow-y-auto flex flex-col justify-between pb-8">
    <div class="px-4 pt-6 space-y-1">

      <ng-container *ngFor="let link of navLinks">

        <ng-container *ngIf="link.children && link.children.length > 0 && isLoggedIn()">
          <button (click)="toggleDropdown(link.label)"
            [class.bg-primary-hover]="padreActivo(link)"
            class="w-full flex items-center justify-between px-3 py-2 rounded-md text-sm text-navbar-text hover:bg-primary-hover transition-colors">
            <span>{{ link.label }}</span>
            <svg class="w-4 h-4 transition-transform duration-200" [class.rotate-180]="openDropdown === link.label"
              fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </button>

          <div *ngIf="openDropdown === link.label" class="pl-3 space-y-1 my-1">
            <a *ngFor="let child of link.children" [routerLink]="child.path" (click)="closeMenu()"
              routerLinkActive="bg-primary-hover"
              class="block px-3 py-2 rounded-md text-navbar-text hover:bg-primary-hover text-sm transition-colors">
              {{ child.label }}
            </a>
          </div>
        </ng-container>

        <a *ngIf="!link.children || link.children.length === 0 || !isLoggedIn()" [routerLink]="link.path"
          routerLinkActive="bg-primary-hover" [routerLinkActiveOptions]="{ exact: !!link.exact }" (click)="closeMenu()"
          class="block px-3 py-2 rounded-md text-navbar-text hover:bg-primary-hover text-sm transition-colors">{{
          link.label }}</a>
      </ng-container>

      <div class="pt-4 mt-3 border-t border-white/10">
        <a *ngIf="!isLoggedIn()" routerLink="/login" (click)="closeMenu()"
          class="flex items-center justify-center gap-2 w-full bg-navbar-text text-primary text-sm font-medium px-4 py-2.5 rounded-lg shadow-sm hover:bg-card hover:shadow-md transition-all duration-200">
          Iniciar sesión
        </a>

        <ng-container *ngIf="isLoggedIn()">
          <div class="flex items-center gap-3 px-3 py-2">
            <div
              class="flex items-center justify-center w-9 h-9 rounded-full bg-navbar-text text-primary text-sm font-semibold">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
              </svg>
            </div>
            <p class="text-sm font-semibold text-navbar-text truncate">{{ userName() }}</p>
          </div>
          <button (click)="logout(); closeMenu()"
            class="flex items-center justify-center gap-2 w-full border border-navbar-text text-navbar-text text-sm font-medium px-4 py-2.5 rounded-lg hover:bg-primary-hover transition-all duration-200">
            Cerrar sesión
          </button>
        </ng-container>
      </div>
    </div>
  </div>
</nav>
